var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getLocales = function () {
    var locales = {};
    var namespaces = ['header'];
    var langs = ['en', 'ru', 'es'];
    langs.forEach(function (lang) {
        namespaces.forEach(function (ns) {
            var _a, _b;
            if (!locales[lang]) {
                locales[lang] = (_a = {},
                    _a[ns] = require("../../locales/" + lang + "/" + ns + ".json"),
                    _a);
            }
            else {
                locales[lang] = __assign(__assign({}, locales[lang]), (_b = {}, _b[ns] = require("../../locales/" + lang + "/" + ns + ".json"), _b));
            }
        });
    });
    return locales;
};
//# sourceMappingURL=getLocales.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/services/getLocales.js
// module id = 1377
// module chunks = 118